import { clsx } from "clsx";

// Full class names must appear as literal strings for tailwind.
const GAP_CLASSES = {
  "0": "gap-0",
  "4": "gap-4",
  "6": "gap-6",
  "8": "gap-8",
} as const;

const PADDING_CLASSES = {
  "0": "pb-0",
  "4": "pb-4",
  "6": "pb-6",
  "8": "pb-8",
} as const;

export type Gap = keyof typeof GAP_CLASSES;

export type DividedProps = React.ComponentProps<"div"> & {
  gap?: Gap;
  children: React.ReactNode;
};

export const Divided: React.FC<DividedProps> = ({
  gap = "4",
  children,
  className,
  ...props
}: DividedProps) => {
  return (
    <div
      {...props}
      className={clsx("flex flex-col divide-y", GAP_CLASSES[gap], className)}
    >
      {!Array.isArray(children)
        ? children
        : children
            .filter((child) => Boolean(child))
            .map((child, i, arr) => {
              const classes = [];
              if (i !== arr.length - 1) {
                classes.push(PADDING_CLASSES[gap]);
              }
              return (
                <div key={i} className={clsx(...classes)}>
                  {child}
                </div>
              );
            })}
    </div>
  );
};
